module.exports = __webpack_public_path__ + "static/media/revenue.04ce5218.webp";